// web/src/utils/sendInternalNotification.js

import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase/firebase";

/**
 * Envia uma notificação interna para o app (badge vermelho + lista).
 *
 * @param {string} uid - ID do usuário que vai receber a notificação
 * @param {string} title - Título da notificação
 * @param {string} message - Texto da notificação
 */
export async function sendInternalNotification(uid, title, message) {
  try {
    await addDoc(collection(db, `users/${uid}/notifications`), {
      title,
      message,
      type: "system",
      createdAt: serverTimestamp(),
      read: false, // ⭐ o app usa isso para mostrar o badge vermelho
    });

    console.log("📢 Notificação interna enviada para:", uid);
  } catch (error) {
    console.error("Erro ao enviar notificação interna:", error);
  }
}
